import React from "react";
import { FormattedMessage } from "react-intl";
import { Spinner, Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import { useOnfidoStatus } from "../../hooks/useOnfidoStatus";
import { IdStatus } from "./idStatus/IdStatus";
import { PoaStatus } from "./poaStatus/PoaStatus";
export const StatusCardContent = ({ signupId }) => {
    const { idStatus, poaStatus, loading, hasStatus, error } = useOnfidoStatus(signupId);
    if (loading) {
        return (React.createElement("div", { className: "loading-wrapper" },
            React.createElement(Spinner, null)));
    }
    if (error) {
        return (React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR },
            React.createElement(FormattedMessage, { id: "onfido.status.retry.message" })));
    }
    if (!hasStatus) {
        return (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "onfido.status.no_statuses" })));
    }
    if (hasStatus) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "onfido.status.general_info" })),
            React.createElement("h3", null,
                React.createElement(FormattedMessage, { id: "onfido.status.id.header" })),
            React.createElement(IdStatus, { idStatus: idStatus }),
            React.createElement("h3", null,
                React.createElement(FormattedMessage, { id: "onfido.status.poa.header" })),
            React.createElement(PoaStatus, { poaStatus: poaStatus })));
    }
    return null;
};
